import Regia1 from '../../../media/SCG/Regia/5/Regia 5.webp'
import Regia2 from '../../../media/SCG/Regia/5/regia-5-d.webp'
import Regia3 from '../../../media/SCG/Regia/5/regia-5-p.webp'


const Regia5images =[
Regia1,Regia2,Regia3
]

export default Regia5images;